import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { LocalStorageService } from './local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class CookiesService {
  private _canUseCookies = new BehaviorSubject<boolean>(false);
  public canUseCookies$ = this._canUseCookies.asObservable();

  constructor(private localStorage: LocalStorageService) {}

  public allowCookies(): void {
    this.localStorage.setInfo({
      canUseCookies: true,
    });

    this._canUseCookies.next(true);
  }

  public denyCookies(): void {
    this.localStorage.setInfo({
      canUseCookies: false,
    });

    this._canUseCookies.next(false);
  }
}
